import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ApiService } from '../../../services/api.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { BreadcrumbComponent } from '../../reusable/breadcrumb/breadcrumb.component';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { clearOrganisationId, clearUIContext, setOrganisationId, setUIContext } from '../../../store/organisation/organisation.actions';
import { CreateBranchComponent } from '../../manage-branches/create-branch/create-branch.component';
import { MultiselectDropdownComponent } from '../../reusable/multiselect-dropdown/multiselect-dropdown.component';
import { OrganisationService } from '../../../services/organisation.service';

@Component({
  selector: 'app-create-organisation',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule, ReactiveFormsModule, ToastrModule, BreadcrumbComponent, MultiselectDropdownComponent],
  templateUrl: './create-organisation.component.html',
  styleUrl: './create-organisation.component.scss',
  providers: [BsModalService]
})

export class CreateOrganisationComponent {
  selectedFile!: File | null;
  organisationId: any;
  parentPage: any;
  organisationData: any;
  organisation: any;
  logoPreview: any;
  logoError: boolean = false;
  @Output() modalClosed = new EventEmitter<void>();
  breadcrumbItems: Array<{ label: string }> = [];
  branchModalRef?: BsModalRef;
  organisationForm: FormGroup = new FormBuilder().group({
    name: [null, [Validators.required, Validators.maxLength(50)]],
    short_name: [null, [Validators.required, Validators.maxLength(4)]],
    // logo: [null],
    official_name: [null, [Validators.required, Validators.maxLength(50)]],
    contact_number: ['' ],
    contact_email: ['' ],
    gst_number: ['', [Validators.maxLength(15)]],
    address: [null],
    corporate_office_address: [null],
    deleted: [false],
    is_uhid_generation_enabled: [true],
    is_visit_id_generation_enabled: [false],
    is_whatsapp_enabled: [false],
    is_teleconsult_enabled: [false],
    is_email_enabled: [false],
    is_sms_enabled: [false],
    dummy: [true],
    group_id: [null],
    two_FA_enabled: [false],
    selectedModules: [[], [Validators.required]],
    is_reminder_sms_enabled: [false],
    is_authorization_enabled: [false],
    is_payment_status_enabled:[false]
  });
  modulesList: any[] = [];
  constructor(
    public modalRef: BsModalRef,
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    private router: Router,
    private store: Store,
    private modalService: BsModalService,
    private organisationService: OrganisationService,
  ) { }

  get modulesControl() {
    return this.organisationForm.get('selectedModules');
  }

  ngOnInit() {
    if (this.parentPage === 'Organization')
      this.breadcrumbItems = [
        { label: 'Organization' },
        { label: 'Create Organization' },
      ];
    else
      this.breadcrumbItems = [
        { label: this.parentPage },
        { label: 'Create Organization' }
      ];
    if (this.organisationId) {
      this.breadcrumbItems[1].label = 'Edit Organization';
      this.getOrganisationData();
    }
    this.store.dispatch(setUIContext({ currentFlow: 'overview-popup' }));
    this.getModulesList();
  }

  getModulesList() {
    this.organisationService.getModulesByOrganisationId(this.organisationId).subscribe({
      next: (res: any) => {
        this.modulesList = res.data;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

  getOrganisationData(): void {
    this.apiService.get(`organisation/${this.organisationId}`).subscribe({
      next: (res: any) => {
        this.organisationData = res.data;
        this.store.dispatch(setOrganisationId({ organisation_id: res?.data?.id }));
        this.organisationForm.patchValue(this.organisationData);
        this.modulesControl?.patchValue(
          this.organisationData?.organisationMappings
            .filter((x: any) => !x.deleted && x.isEnabled)
            .map((x: any) => x?.module?.id)
        );
        if (this.organisationData.logo && this.organisationData.logo.data) {
          this.logoPreview = this.arrayBufferToBase64(this.organisationData.logo.data);
        }
      }
    });
  }

  onSubmit() {
    if (!this.organisationData && !this.selectedFile) {
      this.logoError = true;
    } else {
      this.logoError = false;
    }
    if (this.organisationForm.valid) {
      const formData = new FormData();
      const formControls = this.organisationForm.controls;

      Object.keys(formControls).forEach((key) => {
        let value = formControls[key].value;

        if (value !== null && value !== undefined) {
          if (key === 'selectedModules' && Array.isArray(value)) {
            formData.append(key, value.join(','));
            return;
          }

          if (typeof value === 'boolean') {
            formData.append(key, value ? 'true' : 'false');
          } else {
            formData.append(key, value);
          }
        }
      });

      if (this.selectedFile) {
        formData.append('logo', this.selectedFile);
      }
      if (this.organisationData) {
        // If editing, update the existing organisation
        this.apiService.patch(`organisation/update/${this.organisationData.id}`, formData).subscribe({
          next: (res: any) => {
            this.toastr.success('Organisation updated successfully!', 'Success');
            // this.closeModal();
            if (res && res?.data?.id) {
              this.store.dispatch(setOrganisationId({ organisation_id: res?.data?.id }));
            }
            this.organisationForm.patchValue(res);
          },
          error: (err) => {
            console.error('Error updating organisation:', err);
            this.toastr.error(err.error?.message || 'Failed to update organisation.', 'Error');
          }
        });
      } else {
        // If adding, create a new organisation
        this.apiService.post('organisation', formData).subscribe({
          next: (res: any) => {
            this.toastr.success('Organisation created successfully!', 'Success');
            if (res && res?.data?.id) {
              this.store.dispatch(setOrganisationId({ organisation_id: res?.data?.id }));
              this.organisationData = res?.data;
            }
         
            
          },
          error: (err) => {
            console.error('Error creating organisation:', err);
            this.toastr.error(err.error?.message || 'Failed to create organisation.', 'Error');
          }
        });
      }
    } else {
      this.organisationForm.markAllAsTouched();
    }
  }

  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0] || null;
    if (this.selectedFile) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.logoPreview = e.target.result;
      };
      reader.readAsDataURL(this.selectedFile);
      this.organisationForm.patchValue({ logo: this.selectedFile });
    }
  }

  setupBackdropClickListener() {
    const modalElement = document.querySelector('.modal.show') as HTMLElement;
    const modalDialog = modalElement?.querySelector('.modal-dialog') as HTMLElement;

    if (!modalElement || !modalDialog) return;

    // Add event listener for backdrop click
    modalElement.addEventListener('click', (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      // Check if the click is on the backdrop (not inside the modal dialog)
      if (target === modalElement) {
        this.triggerCloseAnimation(modalElement, modalDialog);
      }
    });
  }

  closeModal() {
    const modalElement = document.querySelector('.modal.show') as HTMLElement;
    const modalDialog = modalElement?.querySelector('.modal-dialog') as HTMLElement;

    if (!modalElement || !modalDialog) return;

    this.triggerCloseAnimation(modalElement, modalDialog);
  }

  triggerCloseAnimation(modalElement: HTMLElement, modalDialog: HTMLElement) {
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes slideOutRight {
        from {
          transform: translateX(0);
        }
        to {
          transform: translateX(100%);
        }
      }
    `;
    document.head.appendChild(style);
    modalDialog.style.animation = 'slideOutRight 0.3s ease-out';

    setTimeout(() => {
      modalElement.style.visibility = 'hidden';
      modalElement.style.pointerEvents = 'none';
      this.modalClosed.emit();
      this.modalRef.hide();
      this.cdr.detectChanges();
      modalDialog.style.animation = '';
    }, 250);
  }

  arrayBufferToBase64(buffer: any): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return 'data:image/png;base64,' + btoa(binary);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setupBackdropClickListener();
    }, 500);
  }

  openBranchModal() {
    this.branchModalRef = this.modalService.show(CreateBranchComponent, {
      class: 'modal-lg my-custom-class',
      backdrop: true,
      ignoreBackdropClick: false,
      keyboard: false,
      animated: true,
      initialState: {
        parentPage: 'Organisation',
      }
    });
  }

  isDeletedChange(e: any): void {
    this.organisationForm.get('deleted')?.setValue(!e?.checked)
  }

  ngOnDestroy() {
    this.store.dispatch(clearOrganisationId());
    this.store.dispatch(clearUIContext());
  }
}
